module.exports = __webpack_public_path__ + "img/not-available.dfe2217.png";